import React from "react";
import { Link } from "react-router-dom";
import { 
  FaBuilding, 
  FaCheckCircle, 
  FaUniversity, 
  FaCertificate,
  FaAward,
  FaFileAlt,
  FaArrowRight
} from "react-icons/fa";
import { MdVerified, MdSchool, MdAccountBalance } from "react-icons/md";
import { BiCertification } from "react-icons/bi";

const AffiliationPage = () => {
  const affiliations = [
    {
      name: "Indian Nursing Council (INC)",
      logo: "/inc-logo.png",
      description: "Approved by Indian Nursing Council, New Delhi",
      recognition: "Nursing Programs",
      number: "Under Processing",
      color: "blue"
    },
    {
      name: "Atal Bihari Vajpayee Medical University",
      logo: "/university-logo.png",
      description: "Affiliated to Atal Bihari Vajpayee Medical University, Lucknow",
      recognition: "All Nursing Programs",
      number: "College Code 222387",
      color: "purple"
    },
    {
      name: "Uttar Pradesh State Medical Faculty",
      logo: "/upsmf-logo.png",
      description: "Recognized by UP State Medical Faculty",
      recognition: "Paramedical Courses",
      number: "College Code 1537",
      color: "orange"
    }
  ];

  const committees = [
    {
      name: "Anti-Ragging Committee",
      chairperson: "Dr. Priya Sharma",
      members: ["Prof. Anil Kumar", "Mr. Rajesh Singh", "Ms. Neha Gupta"],
      contact: "anti.ragging@rdsnursing.edu"
    },
    {
      name: "Internal Complaints Committee",
      chairperson: "Dr. Sunita Verma",
      members: ["Ms. Pooja Mishra", "Adv. Vikas Tripathi", "Mrs. Arti Singh"],
      contact: "icc@rdsnursing.edu"
    },
    {
      name: "Grievance Redressal Committee",
      chairperson: "Prof. R.K. Singh",
      members: ["Dr. Alok Sharma", "Mr. Mohan Das", "Ms. Kiran Yadav"],
      contact: "grievance@rdsnursing.edu"
    },
    {
      name: "Academic Council",
      chairperson: "Sandeep Singh",
      members: ["Dr. Priya Sharma", "Prof. Anil Gupta", "Dr. S.K. Mishra"],
      contact: "academic@rdsnursing.edu"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <nav className="flex text-sm text-gray-500">
            <Link to="/" className="hover:text-blue-600">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/admission" className="hover:text-blue-600">Admission</Link>
            <span className="mx-2">/</span>
            <span className="text-blue-600 font-semibold">RDS - Affiliation</span>
          </nav>
        </div>
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-8 mb-8 text-white">
          <div className="flex items-center gap-4">
            <div className="bg-white/30 p-4 rounded-2xl">
              <FaBuilding className="text-4xl" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold">Affiliations & Recognitions</h1>
              <p className="text-white/90 mt-2">R.D.S. NURSING & PARAMEDICAL COLLEGE - Approved by all relevant bodies</p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1 space-y-6">
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h2 className="text-xl font-bold text-gray-800 mb-4">At a Glance</h2>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <FaUniversity className="text-blue-600" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-gray-800">4</p>
                    <p className="text-xs text-gray-500">Major Affiliations</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <FaCertificate className="text-green-600" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-gray-800">12+</p>
                    <p className="text-xs text-gray-500">Programs Approved</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                    <FaAward className="text-purple-600" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-gray-800">NAAC A+</p>
                    <p className="text-xs text-gray-500">Grade Accreditation</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-r from-blue-600 to-green-600 rounded-2xl p-6 text-white">
              <h3 className="text-lg font-bold mb-2">Verification</h3>
              <p className="text-sm text-white/90 mb-4">
                To verify any affiliation or recognition, please contact our administrative office.
              </p>
              <a href="mailto:affiliation@rdsnursing.edu" className="block text-sm underline">
                affiliation@rdsnursing.edu
              </a>
            </div>
          </div>
          <div className="lg:col-span-2 space-y-6">
            <h2 className="text-2xl font-bold text-gray-800">Our Affiliations & Recognitions</h2>
            {affiliations.map((item, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow">
                <div className="flex items-start gap-4">
                  <div className={`w-16 h-16 bg-${item.color}-100 rounded-xl flex items-center justify-center`}>
                    <BiCertification className={`text-4xl text-${item.color}-600`} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800 mb-1">{item.name}</h3>
                    <p className="text-gray-600 mb-2">{item.description}</p>
                    <div className="flex flex-wrap gap-4 text-sm">
                      <span className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full">
                        {item.recognition}
                      </span>
                      <span className="bg-green-50 text-green-700 px-3 py-1 rounded-full">
                        {item.number}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Recognition Certificates</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-gray-100 h-24 rounded-lg flex items-center justify-center text-gray-400">
                  INC Certificate
                </div>
                <div className="bg-gray-100 h-24 rounded-lg flex items-center justify-center text-gray-400">
                  PCI Certificate
                </div>
                <div className="bg-gray-100 h-24 rounded-lg flex items-center justify-center text-gray-400">
                  University Affiliation
                </div>
                <div className="bg-gray-100 h-24 rounded-lg flex items-center justify-center text-gray-400">
                  NAAC Certificate
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffiliationPage;